"use client";
import React from "react";
import PageLayout from "@/layouts/pageLayout";
import PrivateCloudTabs from "@/components/pageTabs/privateCloudTabs";
import Faqs from "./components/faqs";
import Hero from "./components/hero";
import Intro from "./components/intro";
import FeaturesComponent from "./components/features";
import ServicesComponent from "./components/services";

const OemConvergedArchitecturePage = () => {
  return (
    <PageLayout showContactForm>
      <Hero />
      <PrivateCloudTabs />
      <Intro />
      <FeaturesComponent />
      <ServicesComponent />
      <Faqs />
    </PageLayout>
  );
};

export default OemConvergedArchitecturePage;
